module.exports = __webpack_public_path__ + "img/img-3-13mobile.2d99ea56.webp";